import { configureStore } from '@reduxjs/toolkit'
import { reducer as burgerMenu } from 'redux-burger-menu'
import {
   app,
   article,
   articles,
   brands,
   cards,
   cart,
   catalogs,
   certificates,
   compare,
   filters,
   form,
   home,
   menu,
   order,
   products,
   promo,
   reviews,
   similar
} from './reducers'

const store = configureStore({
   preloadedState: { burgerMenu: { main: { isOpen: false }, filters: { isOpen: false } } },
   reducer: {
      app,
      burgerMenu,
      article,
      articles,
      brands,
      cards,
      cart,
      catalogs,
      certificates,
      compare,
      filters,
      form,
      home,
      menu,
      order,
      products,
      promo,
      reviews,
      similar
   }
})

export default store

// import { persistStore, persistReducer } from 'redux-persist';
// import storage from 'redux-persist/lib/storage';

// const persistConfig = {
//   key: 'root',
//   storage,
//   whitelist: [ 'cart', 'compare'],
// }

// const preloadedState = {
//   burgerMenu: {
//     main: { isOpen: false },
//     filters: { isOpen: false }
//   }
// }

// const reducer = persistReducer(persistConfig, rootReducer)

// const middleware = applyMiddleware( thunk )

// const store = createStore(reducer, preloadedState, composeWithDevTools(middleware))

// export const persistor = persistStore(store)
// export default store

// const preloadedState = {
//   burgerMenu: {
//     main: { isOpen: false },
//     filters: { isOpen: false }
//   }
// }
///////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////

// ROOT REDUCER:
//
//
// import { combineReducers } from 'redux';
// import { reducer as burgerMenu } from 'redux-burger-menu'
// import {
//   appReducer,
//   home,
//   menuReducer,
//   catalogsReducer,
//   sertificatesReducer,
//   brandsReducer,
//   articlesReducer,
//   articleReducer,
//   productsReducer,
//   filtersReducer,
//   productItemsReducer,
//   cartReducer,
//   reviewsReducer,
//   similarProductsReducer,
//   promoReducer,
//   newItemsReducer,
//   compareReducer,
//   orderReducer,
//   form,
// } from './reducers';

// import { persistReducer } from 'redux-persist';
// import storage from 'redux-persist/lib/storage';

// const comparePersistConfig = {
//   key: 'compare',
//   storage: storage,
//   whitelist: ['entities']
// }

// const cartPersistConfig = {
//   key: 'cart',
//   storage: storage,
//   whitelist: ['items']
// }

// const rootReducer = combineReducers({
//   burgerMenu: burgerMenu,
//   app: appReducer,
//   home: homeReducer,
//   menu: menuReducer,
//   catalogs: catalogsReducer,
//   certificates: sertificatesReducer,
//   brands: brandsReducer,
//   articles: articlesReducer,
//   article: articleReducer,
//   products: productsReducer,
//   filters: filtersReducer,
//   productItems: productItemsReducer,
//   cart: persistReducer(cartPersistConfig, cartReducer),
//   reviews: reviewsReducer,
//   similarProducts: similarProductsReducer,
//   promo: promoReducer,
//   newItems: newItemsReducer,
//   compare: persistReducer(comparePersistConfig, compareReducer),
//   order: orderReducer,
//   form: form,
// })

// export default rootReducer
